module.exports = __webpack_public_path__ + "img/poplar-tree.b1780287.svg";